import classNames from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './Stack.module.css';

interface StackProps extends HTMLAttributes<HTMLDivElement> {
  direction?: React.CSSProperties['flexDirection'];
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  alignItems?: React.CSSProperties['alignItems'];
  justifyContent?: React.CSSProperties['justifyContent'];
  flexWrap?: React.CSSProperties['flexWrap'];
}

const Stack = ({
  direction = 'column',
  spacing = 0,
  alignItems,
  justifyContent,
  className,
  flexWrap,
  ...props
}: StackProps): JSX.Element => {
  return (
    <div
      className={classNames(styles.stack, className)}
      style={{
        flexDirection: direction,
        gap: `var(--spacing-${spacing})`,
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexWrap: flexWrap,
      }}
      {...props}
    >
      {props.children}
    </div>
  );
};

export default Stack;
